import React, { useState } from 'react';
import {
  FaCog, FaSync, FaBolt, FaKey, FaSnowflake,
  FaCircle, FaTint, FaGasPump
} from 'react-icons/fa';
import PhoneCTA from './PhoneCTA';
import './Products.css';

const categories = [
  { icon: <FaCog />, name: 'Engines', desc: 'Remanufactured & used engines for all major brands', count: '12,000+', color: '#FF6B6B' },
  { icon: <FaSync />, name: 'Transmissions', desc: 'Automatic & manual transmissions, fully tested', count: '8,500+', color: '#4ECDC4' },
  { icon: <FaBolt />, name: 'Alternators', desc: 'OEM alternators with 1-year warranty', count: '15,000+', color: '#45B7D1' },
  { icon: <FaKey />, name: 'Starters', desc: 'Reliable starter motors for quick ignition', count: '10,200+', color: '#96CEB4' },
  { icon: <FaSnowflake />, name: 'AC Compressors', desc: 'Keep your cabin cool with certified AC parts', count: '6,800+', color: '#74b9ff' },
  { icon: <FaCircle />, name: 'Brake Systems', desc: 'Pads, rotors, calipers & complete brake kits', count: '20,000+', color: '#DDA0DD' },
  { icon: <FaTint />, name: 'Radiators', desc: 'Premium radiators for optimal engine cooling', count: '9,100+', color: '#98D8C8' },
  { icon: <FaGasPump />, name: 'Fuel Systems', desc: 'Fuel pumps, injectors & complete assemblies', count: '7,400+', color: '#F7DC6F' },
];

const Products = () => {
  const [active, setActive] = useState(null);

  return (
    <section className="products" id="products">
      <div className="products-container">
        <div className="section-header">
          <div className="section-badge">OUR INVENTORY</div>
          <h2>Used OEM Auto Parts<br />You Can Trust</h2>
          <p>
            Every part in our inventory is tested, inspected, and graded before listing.
            Find exactly what your vehicle needs from our massive selection.
          </p>
        </div>

        <div className="products-grid">
          {categories.map((cat, i) => (
            <div
              className={`product-card ${active === i ? 'active' : ''}`}
              key={i}
              onMouseEnter={() => setActive(i)}
              onMouseLeave={() => setActive(null)}
              style={{ '--accent': cat.color }}
            >
              <div className="product-icon-wrap">
                <span className="product-icon">{cat.icon}</span>
              </div>
              <div className="product-info">
                <h3>{cat.name}</h3>
                <p>{cat.desc}</p>
                <div className="product-count">
                  <span>{cat.count} Parts</span>
                  <a href="#contact" className="product-link">Browse &rarr;</a>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="products-banner">
          <div className="banner-content">
            <div className="banner-text">
              <h3>Can't find what you're looking for?</h3>
              <p>Our parts experts can source any part within 24–48 hours.</p>
            </div>
            <div className="banner-actions">
              <a href="#contact" className="banner-btn">Request a Part</a>
              <PhoneCTA variant="compact" label="Call For Help" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Products;
